import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";

const RULES = [
  {
    q: "How does a B3B tournament work?",
    a: "Four teams per bracket, 3v3 half-court. Round-robin into a final. Every game matters — point differential breaks ties.",
  },
  {
    q: "How big can my squad be?",
    a: "Register 3 to 5 players. Three on the court at all times, subs on dead balls. No ringers after tip-off.",
  },
  {
    q: "What are the game rules?",
    a: "Games to 21 straight up, or highest score at 12 minutes. Ones and twos, win by 2 in the final. Call your own fouls — street rules, honor system.",
  },
  {
    q: "What happens after I register?",
    a: "Your team is locked into the bracket instantly. The captain gets a confirmation with venue details and tip-off time. Show up 20 minutes early.",
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="rules" data-testid="faq-section" className="px-4 py-16 sm:px-8 sm:py-24 lg:px-16">
      <div className="mx-auto max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-10"
        >
          <p className="font-mono-b3b text-xs uppercase tracking-[0.3em] text-yellow-400">02 / The Rulebook</p>
          <h2 className="mt-3 font-display text-4xl uppercase leading-none tracking-wide sm:text-6xl">
            Know before <span className="text-yellow-400">you hoop</span>
          </h2>
        </motion.div>

        <div className="space-y-3">
          {RULES.map((rule, i) => (
            <motion.div
              key={i}
              data-testid={`faq-item-rules-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="glass-card overflow-hidden rounded-2xl"
            >
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-6 sm:py-5"
              >
                <span className="font-heading text-sm font-bold uppercase tracking-wide text-white sm:text-base">
                  {rule.q}
                </span>
                <motion.span animate={{ rotate: open === i ? 45 : 0 }} transition={{ duration: 0.3 }}>
                  <Plus className="h-5 w-5 shrink-0 text-yellow-400" />
                </motion.span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                  >
                    <p className="px-5 pb-5 text-sm leading-relaxed text-slate-400 sm:px-6">{rule.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
